export default __webpack_public_path__ + "static/media/finance.b0b2a282.svg";